import { IAudienceAggregate, IAudienceAggregateMultiRfm } from 'types/api/audience/aggregate';

export const defaultAggregate: IAudienceAggregate = {
  averageDonation: 0,
  newDonor: 0,
  repeatDonor: 0,
  totalCount: 0,
};

export const defaultAggregateMultiRfm: IAudienceAggregateMultiRfm = {
  aggregate: defaultAggregate,
  sets: [],
};
